import { writable } from 'svelte/store';

function loadVoicesFromLocalStorage() {
    let voices = JSON.parse(localStorage.getItem("cc-voice-defaults")) || [];
    return voices;
}

export const voiceState = writable(loadVoicesFromLocalStorage());

